module.exports = __webpack_public_path__ + "media/smoke-weed-everyday.41bfc938.mp3";